import formatDecimal from '@paradigm/utils/formatDecimal';

import * as Leg from '#/unified-rfqs/ui/rfqs/legs-functions';
import { getProduct } from '#/products/domain';
import { LegTableView } from '#/unified-rfqs/ui/types';
import { GrfqTradeDetailsLeg } from '#/unified-rfqs/entities/grfq/domain';

export default function legsView(legs: readonly GrfqTradeDetailsLeg[] = []) {
  return legs.map((leg, index) => processLeg(leg, index));
}

function processLeg(leg: GrfqTradeDetailsLeg, index: number): LegTableView {
  const { instrument, ratio, side, product_code, price } = leg;
  const product = processProductData(product_code);
  const clearingUnitiesQuantity = clearingUnitiesQuantityView(leg);
  const contractTermsQuantity = contractTermsQuantityView(leg);
  const { contractCurrency } = getProduct(product_code);
  const { expiry, strike, instrumentLabel } = Leg.parseInstrument(instrument);
  return {
    side,
    ratio,
    index,
    expiry,
    instrument,
    clearingUnitiesQuantity,
    contractTermsQuantity,
    instrumentLabel,
    rowNumber: index + 1,
    productLabel: product.label,
    productCurrency: product.currency,
    contractCurrency,
    strike: strike != null ? formatDecimal(strike) : '-',
    price: formatDecimal(price ?? ''),
  };
}

function processProductData(product_code: string) {
  const product = getProduct(product_code);
  const [label = ''] = product.shortName.split('-');
  const { currency } = product;
  return {
    label,
    currency,
  };
}

function clearingUnitiesQuantityView(leg: GrfqTradeDetailsLeg): string {
  const product = getProduct(leg.product_code);
  const currencyQty = formatDecimal(
    (Number.parseFloat(leg.quantity) * product.contractSize).toString(),
  );
  return `${currencyQty} ${product.contractCurrency}`;
}

function contractTermsQuantityView(leg: GrfqTradeDetailsLeg): string {
  const currencyQty = formatDecimal(leg.quantity);
  return `${currencyQty} Cts`;
}
